import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import Switch from 'react-switch';

// Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { showMessage } from '../../../../../helpers/message';

// API
import funcionalidades_api from "../../../../../api/funcionalidades_api"; 
import usuario_api from '../../../../../api/usuario_api';

function PermissoesUsuario({ usuario, setUsuario, handleVoltar, editavel }) {
    const { setLoading } = useAuth();

    // state para funcionalidade e Acoes
    const [funcionalidadesAcoes, setFuncionalidadesAcoes] = useState([]);

    //Função para carregar as funcionalidades do sistema
    const loadFuncionalidadesComAcoes = () => {
        setLoading(true);
        funcionalidades_api.getList().then(response => {
            setFuncionalidadesAcoes(response.data);
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadFuncionalidadesComAcoes();
    }, []);

    //Função de onChange dos campos
    const onChange = (e, acao_id) => {
        const _funcionalidadeAcos = usuario.funcionalidaAcoes.map(funcionalidaAcoes => {
            if (funcionalidaAcoes.funcionalidadeAcao_Id === acao_id) {
                return {
                    ...funcionalidaAcoes,
                    autorizado: e
                };
            }
            return funcionalidaAcoes;
        });

        // Se não houver nenhuma correspondência para o acao_id, adiciona um novo objeto
        if (!_funcionalidadeAcos.some(funcionalidadeAco => funcionalidadeAco.funcionalidadeAcao_Id === acao_id)) {
            _funcionalidadeAcos.push({
                funcionalidadeAcao_Id: acao_id,
                autorizado: e
            });
        }

        setUsuario({
            ...usuario,
            funcionalidaAcoes: _funcionalidadeAcos
        });
    };

    //Função para salvar as permissões
    const handleSalvarPermissoes = () => {
        const _permissoes = usuario.funcionalidaAcoes.filter(v => v.autorizado);

        setLoading(true);
        usuario_api.PostPermissoes(usuario.id, _permissoes)
            .then(response => {
                showMessage("Sucesso", "Operação realizada com sucesso.", "success", handleVoltar);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    return <>
        <Row>
            <h5 className='mb-3'>Lista de Permissões</h5>
        </Row>
        <Row className='d-flex justify-content-start align-items-center mb-4'>
            {funcionalidadesAcoes?.map((value, key) => (
                <Col lg="4" md="6" sm="12" className='mb-3' key={key}>
                    <Card>
                        <CardHeader>{value.descricao}</CardHeader>
                        <CardBody>
                            <Row>
                                {value?.funcionalidadeAcos?.map((acoes, key2) => (
                                    <Col lg="12" md="12" sm="12" key={key2}>
                                        <FormGroup className='d-flex align-items-center'>
                                            <label htmlFor={acoes.funcionalidadeAcao_Id} className='d-flex align-items-center justify-content-center gap-2'>
                                                <Switch
                                                    id={acoes.funcionalidadeAcao_Id.toString()}
                                                    disabled={false}
                                                    className="react-switch"
                                                    checked={
                                                        usuario.funcionalidaAcoes.length > 0 && usuario.funcionalidaAcoes.filter(v => v.funcionalidadeAcao_Id == acoes.funcionalidadeAcao_Id)[0]?.autorizado ? true : false
                                                    }
                                                    onChange={e => onChange(e, acoes.funcionalidadeAcao_Id)}
                                                    onColor="#86d3ff"
                                                    onHandleColor="#2693e6"
                                                />
                                                <span>{acoes.acao}</span>
                                            </label>
                                        </FormGroup>
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
        <Row>
            <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                <Button
                    color='success'
                    className='px-4'
                    onClick={handleSalvarPermissoes}
                >
                    <FontAwesomeIcon icon={faSave} /> Salvar
                </Button>
            </Col>
        </Row>
    </>;
}

export default PermissoesUsuario;